import { getEnumValues } from './common';

export enum Region {
  Australia = 'Australia',
  NewZealand = 'New Zealand',
}

export const ALL_REGIONS = getEnumValues(Region);
